import { gql } from '@/__generated__';
import { GetUsersGraveyardQuery } from '@/__generated__/graphql';

export type GraveyardUser = GetUsersGraveyardQuery['users'][number];

const GET_USERS_GRAVEYARD = gql(`#graphql
  query GetUsersGraveyard {
    users(filter: { deleted: true }) {
      id
      fullName
      email
      deletedAt
      mainOrganization {
        organization {
          id
          name
        }
        role {
          name
        }
      }
    }
  }
`);

export default GET_USERS_GRAVEYARD;
